import React from 'react';
import PropTypes from 'prop-types';
import { FastField, Field } from "formik";
import { Grid, TextField } from "@material-ui/core";
import FieldContainer from "../form-component/container/FieldContainer";

const FormikDisabledField = (props) => {
  const pr = props.formik;
  return(
    <FieldContainer {...props} >
      <FastField
        {...props}
        component={TextField}
        variant={"outlined"}
        fullWidth
        error={Boolean(pr.errors[props.fieldName])}
        value={pr.values && pr.values[props.fieldName]}
        // pr.touched[props.fieldName] &&
        helperText={pr.errors[props.fieldName]}
        size="small"
        disabled={true}
      />
    </FieldContainer>
  )

}

FormikDisabledField.defaultProps ={
  isSetName: true
}
FormikDisabledField.propTypes ={
  fieldName: PropTypes.string,
  formik: PropTypes.any
}

export default FormikDisabledField;
